module.exports = __webpack_public_path__ + "img/3.549c5ec.png";